module.exports = __webpack_public_path__ + "img/img13.d8b46d08.png";